"use strict";

/**
 * @generated SignedSource<<dc8e20e3dd3fc8d7693662b6269d5446>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ViewerFleetCompaniesAsManagerList_ViewerFleetCompanies",
  "selections": [{
    "alias": null,
    "args": null,
    "concreteType": "FleetCompany",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [{
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }, {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    }, {
      "alias": null,
      "args": null,
      "concreteType": "FleetContract",
      "kind": "LinkedField",
      "name": "contract",
      "plural": false,
      "selections": [{
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "shortCode",
        "storageKey": null
      }],
      "storageKey": null
    }],
    "storageKey": null
  }],
  "type": "FleetCompanyEdge",
  "abstractKey": null
};
node.hash = "6cccd594608b531f8deeb4bdc60b32b7";
export default node;